import { useId, useState, type ReactNode } from "react";

export interface TabItem {
  id: string;
  label: string;
  content: ReactNode;
}

export function Tabs({
  items,
  initial,
  onChange,
}: {
  items: TabItem[];
  initial?: string;
  onChange?: (id: string) => void;
}) {
  const [active, setActive] = useState(initial ?? items[0]?.id);
  const baseId = useId();
  const current = items.find((i) => i.id === active) ?? items[0];
  return (
    <div>
      <div role="tablist" className="bt-tabs__list">
        {items.map((item) => (
          <button
            key={item.id}
            role="tab"
            id={`${baseId}-tab-${item.id}`}
            aria-selected={item.id === current?.id}
            aria-controls={`${baseId}-panel-${item.id}`}
            onClick={() => {
              setActive(item.id);
              onChange?.(item.id);
            }}
            className="bt-tabs__tab"
          >
            {item.label}
          </button>
        ))}
      </div>
      {current ? (
        <div
          role="tabpanel"
          id={`${baseId}-panel-${current.id}`}
          aria-labelledby={`${baseId}-tab-${current.id}`}
        >
          {current.content}
        </div>
      ) : null}
    </div>
  );
}
